import React from 'react'
import {Box} from '@chakra-ui/react'
import Header from '../components/About.js/Header'
import Section from '../components/About.js/Section'
import Team from '../components/About.js/Team'
import Values from '../components/About.js/Values'
import Cta from '../components/Common/Cta'
import Faq from '../components/Common/Faq'
import Footer from '../components/Common/Footer'
import Navbar from '../components/Navbar'
import Newsletter from '../components/Common/Newsletter'

const About = () => {
  return (
    <>
    <Navbar/>
    <Header/>
    <Box display={['none','block']} >
      <Section/>
    </Box>
    
    <Values/>
    <Team/>
    <Cta/>
    <Faq/>
    <Newsletter/>
    <Footer/>
    </>
  )
}

export default About